import ApplicationController from './application_controller'

export default class extends ApplicationController {
	static targets = ["submitBtn", "emojiSequence"]
	connect () {
		//find the location of the mouse
		//...
		//
	}
}